import { post } from '../Services/http';
import { catchError } from './Error.action';

export const HTTP_ERROR = "HTTP_ERROR"
export const FAVOURITES_LOAD = "FAVOURITES_LOAD";
export const FAVOURITES_LOAD_ERROR = "FAVOURITES_LOAD_ERROR";
export const FAVOURITES_RECEIVE = "FAVOURITES_RECEIVE";
export const FAVOURITES_TOGGLE = "FAVOURITES_TOGGLE";


export const setfavourites = (favs) => (dispatch) => { 
    return post('/api/favourites', { requestModel: favs })
        .then(response => response.json())
        .then(data => dispatch(toggleFavourite(favs.variantSystemId))) 
        .catch(ex => dispatch(catchError(ex, error => {
            return loadError(error)
        })));

}
export const loadError = error => ({
    type: FAVOURITES_LOAD_ERROR,
    payload: {
        error
    }
});

export const receive = data => ({
    type: FAVOURITES_RECEIVE,
    payload: {
        favouritesdata: data
    }
});


export const toggleFavourite = variantSystemId => ({
    type: FAVOURITES_TOGGLE,
    payload: {
        variantSystemId
    }
});